export const NotificationsIcon = ({ width = 112, height = 156 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 112 156"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M61.7084 30.6263C61.7084 27.7498 59.3765 25.418 56.5001 25.418C53.6236 25.418 51.2917 27.7498 51.2917 30.6263V34.5326H48.3885C36.7996 34.5326 27.2079 43.543 26.4845 55.1093L25.3335 73.5128C24.8946 80.5294 22.5389 87.2911 18.523 93.0616C14.8944 98.2754 18.1248 105.476 24.4317 106.233L42.1771 108.363V113.96C42.1771 121.87 48.5897 128.283 56.5001 128.283C64.4104 128.283 70.823 121.87 70.823 113.96V108.363L88.5684 106.233C94.8753 105.476 98.1056 98.2754 94.4771 93.0616C90.4611 87.2912 88.1055 80.5294 87.6666 73.5128L86.5155 55.1093C85.7921 43.543 76.2005 34.5326 64.6116 34.5326H61.7084V30.6263ZM49.9896 113.96C49.9896 117.555 52.9045 120.47 56.5001 120.47C60.0957 120.47 63.0105 117.555 63.0105 113.96V110.053H49.9896V113.96Z"
      fill="#525252"
    />
  </svg>
);
